var GeoYandexProvider = {
    params: {
        debug: true,
        yandexApiKey: '',
    },
    data: {},
    Loader: null,

    init: function (scriptLoaderInterface, params) {
        this.Loader = scriptLoaderInterface;
        this.params = this._extendParams(this.params, params);
        return this;
    },

    _extendParams: function () {
        for (var i = 1; i < arguments.length; i++) {
            for (var key in arguments[i]) {
                if (arguments[i].hasOwnProperty(key)) {
                    arguments[0][key] = arguments[i][key];
                }
            }
        }
        return arguments[0];
    },

    get: function () {
        var self = this;

        return new Promise(function (resolve, reject) {
            if (self.data.length) {
                resolve(self.data);
            } else {
                self.Loader.load("//api-maps.yandex.ru/2.1/?load=package.search&lang=ru_RU&apikey=" + self.params.yandexApiKey, function () {
                    self._get(resolve);
                });
            }

        });
    },

    _get: function (callback) {
        var self = this;
        ymaps.ready(function () {
            var geolocation = ymaps.geolocation, provider = 'auto';

            geolocation.get({
                provider: provider,
                mapStateAutoApply: true
            }).then(function (result) {
                if (self.params.debug) {
                    console.log(result.geoObjects.get(0).properties.get('metaDataProperty'));
                }
                for (var key in result.geoObjects.get(0).properties.get('metaDataProperty').GeocoderMetaData.Address.Components) {
                    var kind = result.geoObjects.get(0).properties.get('metaDataProperty').GeocoderMetaData.Address.Components[key].kind,
                            value = result.geoObjects.get(0).properties.get('metaDataProperty').GeocoderMetaData.Address.Components[key].name;
                    if (typeof self.data[kind] == "undefined") {
                        self.data[kind] = [];
                    }
                    self.data[kind].push(value);
                }
                callback(self.data);
            });
        });

    },

};

var GeoStorageController = {
    changed: false,

    get: function () {
        return $("html").data("geo");
    },

    set: function (data) {
        var self = this;

        return new Promise(function (resolve, reject) {

            var xmlHttp = new XMLHttpRequest();
            xmlHttp.onreadystatechange = function () {
                if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                    if (xmlHttp.responseText) {
                        var response = JSON.parse(xmlHttp.responseText);
                        if (typeof response.name != "undefined") {
                            $("html").data("geo", response.name);
                            self.changed = self.get() != response.name;
                            resolve(self);
                        }

                    }
                }
            }
            xmlHttp.open("GET", '/ajax/?action=geo&' + param(data) + '&_=' + Date.now(), true);
            xmlHttp.send(null);

        })

    }


};


var GeoPlaceholderObserver = {
    GeoController: null,
    init: function (GeoController, Render) {
        var self = this;
        this.GeoController = GeoController;
        this.GeoController.registerObserver(this);

        Render.add('.geo__placeholder', function () {
            self.update();
        })

        return this;
    },

    update: function () {
        var self = this;
        $('.geo__placeholder').each(function () {
            var city = self.GeoController.getCity();
            if (city)
                $(this).addClass("geo__placeholder_active");
            $(".geo__placeholder-text", this).html(self.GeoController.getCity());
        })
    }

};

var GeoDialogObserver = {
    GeoController: null,
    GeoRefresher: null,
    GeoCityList: null,
    popup: null,

       init: function (GeoController, GeoCityList, GeoRefresher, popup) {
        this.popup = popup;
        this.GeoRefresher = GeoRefresher;
        this.GeoCityList = GeoCityList;
        this.GeoController = GeoController;
        this.GeoController.registerObserver(this);
        return this;
    },

    open: function () {
        var self = this;
        self.popup.open();
        $(".geo__dialog-city", this.popup.el).html(this.GeoController.getCity());
    },

    update: function () {
        this.open();
        this.GeoController.removeObserver(this);
    },

        no: function () {
        this.GeoCityList.open();
    },

    yes: function () {
        this.GeoRefresher.execute();
    },

};


var GeoRefresher = {
    RouteInterface: null,
    init: function (RouteInterface) {
        this.RouteInterface = RouteInterface;
        return this;
    },

    execute: function () {
        this.RouteInterface.reload();
    }
};


var GeoCityList = {
    autocomplete: null,
    created: false,
    GeoController: null,
    GeoRefresher: null,

    init: function (GeoController, GeoRefresher) {
        var self = this;
        this.GeoController = GeoController;
        this.GeoRefresher = GeoRefresher;

        this.autocomplete = app.autocomplete.create({
            openIn: 'popup', 
            openerEl: '#autocomplete-geo-popup', 
            closeOnSelect: true, 
            routableModals: false,
            pageTitle: 'Ваше местоположение',
            popupCloseLinkText: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg svg__close svg-inited rendered replaced-svg"><path stroke="#444341" d="M3.354 3.646l16.714 16.715m-16.136 0L20.646 3.646"></path></svg>',
            searchbarPlaceholder: "Поиск...",
            notFoundText: "Ничего не нашли",
            multiple: false,
            source: function (query, render) {
                var autocomplete = this;
                var results = [];
                if (query.length === 0) {
                    render(results);
                    return;
                }
                autocomplete.preloaderShow();
                app.request({
                    url: '/ajax/?action=geo_cities',
                    method: 'GET',
                    dataType: 'json',
                    data: {
                        query: query
                    },
                    success: function (data) {
                        autocomplete.preloaderHide();
                        result = [];
                        data.forEach(elem => {
                            result.push({
                                id: elem.id,
                                text: elem.value + "<div><small>" + elem.location + "</small></div>",
                                city: elem.value
                            });
                        })
                        render(result);
                    }
                });
            },
            on: {
                change: function (value) {
                    if (value.length) {
                        let data = {
                            id: value[0].id
                        };
                        self.GeoController.update(data).then(function () {
                            self.GeoRefresher.execute();
                        })
                    }
                },
            },

        });

                $("body").on("click", '.geo__list-open', function () {
            GeoCityList.open();
        });
    },


    open: function () {
        this.autocomplete.open();
    }

};

var GeoController = {
    providerIndex: 0,
    providers: [],
    observers: [],
    Storage: null,

    init: function (Storage) {
        this.Storage = Storage;
        return this;
    },

    registerProvider: function (Provider) {
        this.providers.push(Provider);
        return this;
    },

    providersChainExecute: function () {
        var self = this;
        if (this.providers && this.providers[self.providerIndex]) {
            this.providers[self.providerIndex]
                    .get()
                    .then(city => {
                        self.update(city);
                    })
                    .catch(error => {
                        if (error) {
                            console.error(error);
                        }

                        self.providerIndex++;
                        self.providersChainExecute();
                    });
        }
    },

    registerObserver: function (Observer) {
        let found = false;
        if (!this.observers.some(function (AddedObserver, index) {
            return Observer == AddedObserver;
        })) {
            this.observers.push(Observer);
        }
        return this;
    },

    removeObserver: function (Observer) {
        var self = this;
        this.observers.some(function (AddedObserver, index) {
            let found = Observer == AddedObserver;
            if (found) {
                self.observers.splice(index, 1);
            }

            return found;
        });

        return this;
    },

    notyfyObservers: function (city, changed) {
        if (this.observers.length) {
            this.observers.forEach(function (Observer, index) {
                if (typeof Observer.update == 'function') {
                    Observer.update();
                }
            });
        }

    },

    getCity: function () {
        return this.Storage.get();
    },

    changed: function () {
        return this.Storage.changed;
    },

    execute: function () {
        var self = this;

        if (this.getCity()) {
            this.notyfyObservers();
        } else {
            if (this.providers.length) {
                this.providersChainExecute();
            }
        }


    },

    update: function (city) {
        var self = this;

        return this.Storage
                .set(city)
                .then(Storage => {
                    self.notyfyObservers();
                });

    },

};


            GeoController
        .init(GeoStorageController)
        .registerProvider(
                GeoYandexProvider.init(
                        scriptLoaderInterface,
                        {
                            yandexApiKey: Consts.yandexApiKey,
                        }
                )
        );


GeoPlaceholderObserver.init(GeoController, Render);

GeoRefresher.init(RouteInterface);
GeoCityList.init(GeoController, GeoRefresher);

if (1 == 0 && !GeoController.getCity()) {
    GeoDialogObserver.init(
            GeoController,
            GeoCityList,
            GeoRefresher,
            app.actions.create({
                closeByBackdropClick: false,
                buttons: [
                    [
                        {
                            text: '<div class="geo__dialog"><div><div class="geo__dialog-title"></div><div>Ваш город <span class="geo__dialog-city"></span>?</div></div></div>',
                            label: true
                        }
                    ],
                    [
                        {
                            text: 'Да',
                            onClick: function () {
                                GeoDialogObserver.yes();
                            }
                        }
                    ],
                    [
                        {
                            text: 'Нет',
                            onClick: function () {
                                GeoDialogObserver.no();
                            }
                        }
                    ]
                ]
            })
            );
}

GeoController.execute();

